export default __webpack_public_path__ + "static/media/iToken DM.4af0cd02.svg";